import { render, staticRenderFns } from "./onlineExamStatistics_seeStudent.vue?vue&type=template&id=65b1b0ad&scoped=true"
import script from "./onlineExamStatistics_seeStudent.vue?vue&type=script&lang=js"
export * from "./onlineExamStatistics_seeStudent.vue?vue&type=script&lang=js"
import style0 from "./onlineExamStatistics_seeStudent.vue?vue&type=style&index=0&id=65b1b0ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b1b0ad",
  null
  
)

export default component.exports